import { render, staticRenderFns } from "./NakesEdit.vue?vue&type=template&id=49cd4368&scoped=true"
import script from "./NakesEdit.vue?vue&type=script&lang=js"
export * from "./NakesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd4368",
  null
  
)

export default component.exports